import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div
      dir="rtl"
      style={{
        textAlign: "center",
        padding: "80px 20px",
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxSizing: "border-box"
      }}
    >
      <h1 style={{ marginBottom: "15px" }}>
        404 – העמוד המבוקש לא נמצא
      </h1>

      <p style={{ lineHeight: "1.9", maxWidth: "600px", marginBottom: "30px" }}>
        אנו מתנצלים, אך לא ניתן להציג את העמוד המבוקש.
        <br />
        ייתכן שהכתובת שהוזנה אינה תקינה, או שהעמוד הועבר או הוסר מהאתר.
        <br />
        <br />
        נשמח לעמוד לרשותכם ולסייע בכל שאלה או פנייה משפטית
      </p>

      <Link
        to="/"
        style={{
          display: "inline-block",
          padding: "12px 28px",
          backgroundColor: "#c9142d",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
          fontWeight: "600"
        }}
      >
        חזרה לעמוד הראשי
      </Link>
    </div>
  );
}

export default NotFound;
